<template>
  <div class="modal fade" id="video-tutorial-dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          <h4 class="modal-title"> Tutorial </h4>
        </div>
        <div class="modal-body text-center" v-if="url">
          <video width="640" height="480" controls ref="video">
            <source :src="url" type="video/mp4">
            Your browser does not support the video tag.
          </video>
        </div>
        <div class="modal-footer">
          <button id="session-timeout-dialog-keepalive" type="button" class="btn green" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "VideoTimeoutModal",
    props: {
      url: {
        type: String,
        required: false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// VideoTutorialModal.vue?0c243e2a